<template>
  <div>
    <van-cell title="SIM卡合计:" :value='totals' />
    <van-pull-refresh :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <van-collapse-content :list="lists" :searchValue="searchValue"></van-collapse-content>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import vanCollapseContent from './SimVanCollapseContent.vue'
import {
  SimList
} from '@/api/Equipment.js'

export default {
  name: 'SimTab',
  components: {
    vanCollapseContent
  },
  props: {
    searchValue: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      lists: [], // 【核心】这是我们将要维护并传给子组件的数据
      totals: 0,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: this.searchValue,
        type: this.$route.params?.type
      },
      finishedText: '没有更多了',
      refreshingFlag: false
    }
  },
  watch: {
    // 监听外部传入的 searchValue 变化，重置搜索
    searchValue (newVal) {
      this.paramsList.iccid = newVal
      this.onRefreshs()
    }
  },
  methods: {
    // 触底获取信息
    async onLoad () {
      // 【修复点1】加入登录检查
      if (!this.$store.state.token) {
        this.$router.push('/login')
        this.$toast.fail('登录失效，请重新登录')
        this.loading = false
        this.finished = true
        return
      }

      if (this.searchValue) {
        this.$set(this.paramsList, 'iccid', this.searchValue)
      }

      try {
        const {
          data: res
        } = await SimList(this.paramsList)

        // 【修复点2】检查后端返回的登录状态
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login')
          this.$toast.fail('请重新登录')
          this.loading = false
          this.finished = true
          return
        }

        const {
          rows
        } = res.extend

        // 【修复点3】更新总数
        this.totals = res.extend.records

        // 【修复点4】分页逻辑修正：追加数据，而不是覆盖
        if (rows && rows.length > 0) {
          this.lists.push(...rows)

          // 判断是否还有下一页
          if (rows.length >= this.paramsList.limit) {
            this.paramsList.page++
          } else {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      } catch (err) {
        console.error(err)
        this.$toast.fail('加载失败')
        this.finished = true
      } finally {
        this.loading = false
        this.refreshing = false
        this.$nextTick(() => {
          this.refreshingFlag = false
        })
      }
    },
    // 下拉刷新
    onRefreshs () {
      this.refreshingFlag = true
      this.finished = false
      this.paramsList.page = 1
      this.lists = [] // 清空本地数据

      this.loading = true
      this.onLoad()
    }
  },
  mounted () {

  }
}
</script>

<style scoped lang='less'>
</style>
